import { useMemo } from 'react';
import styled from '@emotion/styled';

import { Link, useNavigate } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, IconButton, Button, Tooltip } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import { relativeTime, formatPhoneNumber, formatGenericDateTime, formatGenericDate } from '../../../utils/util';

import { BasicFlex, Notes, LabelUpper } from '../../../utils/Common';

import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import EditOutlined from '@mui/icons-material/EditOutlined';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import { useQuery } from '@tanstack/react-query';

import { getAppliedPayments } from '../apiService';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import { startCase } from 'lodash';

import AppliedPayments from '../../Invoices/Components/AppliedPayments';

const DetailsTab = () => {
  const { data = {} } = usePageData();

    const { data: payments } = useQuery({
      queryKey: ['payments', 'applied', data.payment_id],
      queryFn: () => getAppliedPayments(data.payment_id),
      enabled: !!data.payment_id
    });
  
    console.log(payments, "payments");

  const custBlock = [
    {header: "Customer", info: data.customer_name},
    {header: "Phone", info: formatPhoneNumber(data.customer_phone)},
  ]

  const basicBlock = [
    {header: "Payment Num", info: `#${data.payment_num}`},
    {header: "Amount", info: data.amount, dataType: "currency"},
    {header: "Available Amount", info: data.available_amount, dataType: "currency"},
    {header: "Method", info: startCase(data.method)},
    {header: "Info", info: data.info || "N/A"},
    {header: "Date", info: data.date, dataType: "date"},
  ]

  const cc_info = [
    {header: "Entry", info: startCase(data.payment_entry_method)},
    {header: "Gateway", info: data.gateway_name || "N/A"},
    {header: "CC Fee Used", info: data.use_cc_fee ? "Yes" : "No"},
    {header: "CC Rate", info: data.cc_rate, dataType: "percentage"},
    {header: "CC Fee", info: data.cc_fee, dataType: "currency"},
    {header: "Total Charged Amount", info: data.display_amount, dataType: "currency"},
  ]

  return (
    <Grid container spacing={3}>

      <Grid size={{xs: 12, md: 4}}>

        <Card variant="outlined">
          <CardHeader title="Payment Details" action={<Tooltip title="Edit Payment"><Link to={`/payments/edit/${data?.payment_id}`}><IconButton color="info"><EditOutlined /></IconButton></Link></Tooltip>} />
          <CardContent>
            <CardBlockContainer>

              {custBlock.map((block, i) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />

              <CardBlockHeader>
                Payment Info
              </CardBlockHeader>

              {basicBlock.map((block, i) => (
                <CardBlock key={block.header} {...block} />
              ))}

              {data.method === "credit_card" && (
                <>
                  <CardSpacer />
                  <CardBlockHeader>
                    Credit Card Info
                  </CardBlockHeader>
                  {cc_info.map((block, i) => (
                    <CardBlock key={block.header} {...block} />
                  ))}
                </>
              )}

              <CardSpacer />
              <CardBlockHeader>Notes</CardBlockHeader>
              <Notes>{data.notes}</Notes>

            </CardBlockContainer>
          </CardContent>
        </Card>

      </Grid>

      <Grid size={{xs: 12, md: 8}}>

        <AppliedPayments payments={payments} />

      </Grid>

    </Grid>
  );

};

export default DetailsTab;